// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DB5n","option":"styles_option__3EpWp","active":"styles_active__25sq9"};